import React from 'react';
import { createRoot } from 'react-dom/client';

import BaseModule from '../../../javascripts/helpers/baseModule';

import FocusFilter from './components/FocusFilter.jsx';

export default class TeaserRegions extends BaseModule {
  constructor(element) {
    super(element, 'teaser-focus-filter');

    this.init();
  }

  init() {
    const config = JSON.parse(this.elements.self.dataset.jsModuleConfig);
    const root = createRoot(this.elements.self);
    root.render(<FocusFilter data={config} />);
  }
}
